import request from '@/utils/request';
import { endpoints, taskTemplateEndpoint } from '@/constants/urls';

const taskTemplates = (filter, page, pageSize) => (request({
  url: endpoints.TASK_TEMPLATES,
  params: { filter, page, pageSize },
  method: 'GET',
}));

const taskTemplate = (code) => request({
  url: taskTemplateEndpoint(code),
  method: 'GET',
});

export default {
  taskTemplates,
  taskTemplate,
};
